// ko strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  // Rendered as "<count> <on>" after the platform icons.
  "hub.views.count": "100억 회 이상",
  "hub.views.on": "조회",
  "hub.badge.covers": "1,000만 개 이상의 커버 제작",
  "hub.badge.quality": "스튜디오급 품질",
  "hub.badge.youtube": "YouTube에서 화제",
  "hub.trending": "인기 급상승",
  "hub.popular": "지금 인기 있는 목소리",
  "hub.browseAll": "모두 보기",
  "hub.byCategory": "카테고리별 목소리 둘러보기",
  "hub.aiVoices": "AI 목소리",
  "hub.howItWorks": "이용 방법",
  "hub.faq": "자주 묻는 질문",
  "hub.keepExploring": "더 둘러보기",
  "hub.moreWays": "Jammable로 만들 수 있는 더 많은 방법.",
  "hub.home": "홈",

  "widget.title": "목소리를 골라 시작하세요",
  "widget.search": "목소리 검색",
  "widget.clear": "검색어 지우기",
  "widget.matching": '"{q}" 검색 결과',
  "widget.popular": "지금 인기",
  "widget.noMatch": "검색과 일치하는 목소리가 없어요.",
  "widget.searchAny": "위에서 원하는 목소리를 검색해 보세요.",
  "widget.coverWith": "{name} 목소리로 커버 만들기",
  "widget.start": "원하는 목소리로 시작하기",
  "widget.rights":
    "다음 단계에서 오디오를 추가해요. 사용할 권리가 있는 오디오만 업로드하세요.",

  "lang.viewThisPage": "이 페이지를 한국어로 보기",
  "lang.dismiss": "닫기",
};

export default hub;
